import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlink, faCalendar, faCoins } from "@fortawesome/free-solid-svg-icons";
import Address from "../../../../../../finance/content/outgoing/SubComponents/Address";
import StatusIcons from "../../../../../../finance/content/outgoing/SubComponents/StatusIcons";

const FinanceCard = ({ bill, AddButton = null, unlinkFunction }) => {
  return (
    <div className="col-sm-6" style={{ marginBottom: "12px" }}>
      <div style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}>
        {/* Header */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: "1px solid #f0f0f0",
          background: "#fafafa",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0 }}>
            <span style={{
              background: "#e8f0fe",
              color: "#1a73e8",
              borderRadius: "6px",
              padding: "2px 8px",
              fontSize: "0.75rem",
              fontWeight: 700,
              whiteSpace: "nowrap",
            }}>
              #{bill.id}
            </span>
            <span style={{
              fontWeight: 600,
              fontSize: "0.88rem",
              color: "#212121",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}>
              {bill.betreff}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
            <StatusIcons
              payed={bill.geldeingang}
              draft={bill.draft}
              subscription={bill.aborechnung}
              privateButton={bill.privat}
            />
            {unlinkFunction && (
              <button
                onClick={unlinkFunction}
                title="Unlink"
                style={{
                  background: "#ffebee",
                  color: "#c62828",
                  border: "none",
                  borderRadius: "6px",
                  width: "26px",
                  height: "26px",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "0.72rem",
                  flexShrink: 0,
                }}
              >
                <FontAwesomeIcon icon={faUnlink} />
              </button>
            )}
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: "12px 16px", flex: 1 }}>
          <Address addressJson={bill.fixed_address} />
        </div>

        {/* Footer */}
        <div style={{
          padding: "10px 16px",
          borderTop: "1px solid #f0f0f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#fff",
          flexWrap: "wrap",
          gap: "8px",
        }}>
          <div style={{ display: "flex", gap: "16px" }}>
            {bill.datum && (
              <span style={{ fontSize: "0.8rem", color: "#757575", display: "flex", alignItems: "center", gap: "4px" }}>
                <FontAwesomeIcon icon={faCalendar} style={{ fontSize: "0.72rem" }} />
                {bill.datum}
              </span>
            )}
            {bill.netto != null && (
              <span style={{ fontSize: "0.8rem", color: "#424242", display: "flex", alignItems: "center", gap: "4px" }}>
                <FontAwesomeIcon icon={faCoins} style={{ fontSize: "0.72rem", color: "#9e9e9e" }} />
                <span style={{ color: "#9e9e9e", marginRight: "2px" }}>Net</span>
                <strong>{bill.netto}</strong>
                {bill.brutto != null && (
                  <span style={{ color: "#9e9e9e", margin: "0 2px 0 6px" }}>Gross</span>
                )}
                {bill.brutto != null && <strong>{bill.brutto}</strong>}
              </span>
            )}
          </div>
          {AddButton && <AddButton financeId={bill.id} />}
        </div>
      </div>
    </div>
  );
};

export default FinanceCard;
